import { Box } from "./Box.js";
import { Button } from "./Button.js";
import { ImageBox } from "./ImageBox.js";
import { Text } from "./Text.js";
import { TextInput } from "./TextInput.js";
import "./UIElement.js";
import "./Rectangle.js";
import "nanoid";
import "./utils.js";
import "lodash";
import "./UIService.js";
import "../global-33d5eebf.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "../console/flags.js";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
const createByType = (config) => {
  switch (config.type) {
    case "box":
      return new Box(config.rect, config.config);
    case "text":
      return new Text(config.rect, config.config);
    case "button":
      return new Button(config.rect, config.config);
    case "input":
      return new TextInput(config.rect, config.config);
    case "animatedImageBox":
      throw new Error("AnimatedImageBox is not supported yet");
    case "image":
      return new ImageBox(config.rect, config.config);
    default:
      throw new Error(`Unknown UI type ${config.type}`);
  }
};
export {
  createByType
};
//# sourceMappingURL=UiConfigs.js.map
